"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PassengerListOptionsItem = void 0;
const react_1 = __importDefault(require("react"));
const CheckBox_1 = require("../../../../CheckBox");
const Icon_1 = require("../../../../Icon");
const Tooltip_1 = require("../../../../Tooltip");
require("./index.scss");
const className = 'reservation-passengers-options-block-item';
const PassengerListOptionsItem = (props) => {
    const { isChecked, onChange, title, tooltip, disabled, warning, } = props;
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement("div", { className: `${className}__checkbox` },
            react_1.default.createElement(CheckBox_1.CheckBox, { checked: isChecked, onChange: (event) => {
                    const { checked } = event.target;
                    onChange({ isChecked: checked });
                }, text: title, disabled: disabled, modificators: warning ? 'warning' : undefined })),
        tooltip && (react_1.default.createElement("div", { className: `${className}__info` },
            react_1.default.createElement(Tooltip_1.Tooltip, { text: tooltip, modificators: warning ? 'warning' : undefined },
                react_1.default.createElement(Icon_1.Icon, { name: warning ? 'warning' : 'info-circle' }))))));
};
exports.PassengerListOptionsItem = PassengerListOptionsItem;
//# sourceMappingURL=index.js.map